RivalIQ.apps.Shell.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.PaywallModal = Marionette.CompositeView.extend({

        template: '#shellPaywallModal',
        className: 'modal',
        backdrop: 'static',
        blur: true,

        ui: {
            contactUsBtn: '.x-contact-us'
        },

        events: {
            'click @ui.contactUsBtn': 'onContactUsClick'
        },

        templateHelpers: function () {

            return {
                hasPlanOptions: !RivalIQ.state.plan.get('has_quid_compete_branding')
            };
        },

        onBeforeShow: function () {
            const me = this;
            if (me.getOption('blur')) {
                $('body').addClass('blur-content');
            }
        },

        onShow: function () {
            const me = this;
            me.$el.modal({
                backdrop: me.getOption('backdrop')
            });
        },

        onContactUsClick: function () {
            RivalIQ.execute('show:modal', new RivalIQ.apps.Shell.views.ContactUsModal({
                model: new Backbone.Model({
                    context: 'trial expired paywall'
                })
            }));
        }
    });
});
